import type {CopilotChatCommandType} from './copilot-chat-types'
import {copilotFeatureFlags} from './copilot-feature-flags'

export function extractChatCommandType(
  text: string,
  availableCommandsKeys: CopilotChatCommandType[],
): CopilotChatCommandType | null {
  // Early return if no commands are allowed (undefined or empty array)
  if (availableCommandsKeys.length === 0) {
    return null
  }

  if (!copilotFeatureFlags.chatInputCommands) {
    return null
  }

  const pattern = new RegExp(`^\\/(${availableCommandsKeys.join('|')})(?:\\s|$)`, 'i')

  const match = text.match(pattern)
  if (match && match[1]) {
    // Type assertion is safe here because the regex pattern is built from availableCommandsKeys
    const command = match[1].toLowerCase() as CopilotChatCommandType

    return command
  }

  return null
}
